import { faqConstants } from '../constants/faq';

const initialState = {
  tree: [],
  list: [],
  page: {},
  glossary: {},
  lastUpdate: [],
  searchList: [],
  recommendation: {},
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case faqConstants.SET_FAQ_TREE_LIST_SUCCESS:
      return {
        ...state,
        tree: action.tree,
      };

    case faqConstants.SET_FAQ_PAGE_SUCCESS:
      return {
        ...state,
        page: action.page,
      };

    case faqConstants.SET_FAQ_RECOMMENDATION_SUCCESS:
      return {
        ...state,
        recommendation: action.recommendation,
      };

    case faqConstants.SET_FAQ_GLOSSARY_SUCCESS:
      return {
        ...state,
        glossary: action.glossary,
      };

    case faqConstants.SET_FAQ_LIST_SUCCESS:
      return {
        ...state,
        list: action.list,
      };

    case faqConstants.SET_FAQ_LAST_UPDATE_SUCCESS:
      return {
        ...state,
        lastUpdate: action.lastUpdate,
      };

    case faqConstants.SET_FAQ_SEARCH_SUCCESS:
      return {
        ...state,
        searchList: action.searchList,
      };

    default:
      return state;
  }
};
